import React from 'react';
import './Navigation.css';

const Navigation = ({ 
  children, 
  variant = 'default',
  className = '',
  ...props 
}) => {
  const baseClasses = 'nav';
  const variantClasses = `nav-${variant}`;
  
  const classes = [baseClasses, variantClasses, className]
    .filter(Boolean)
    .join(' ');

  return (
    <nav
      className={classes}
      {...props}
    >
      {children}
    </nav>
  );
};

export default Navigation;

